import axios from "axios";
import { logoutAndRedirect } from "../lib/axiosInterceptor";

// export const api_server = 'https://opvc.instavc.com/api';
// const {api_server} = config;

/**
 * Check if error is a session expiration error
 */
const isSessionExpiredError = (error) => {
    if (error.response) {
        const { status, data } = error.response;
        if (status === 401 && data && data.error) {
            const errorMessage = typeof data.error === "string" ? data.error : "";
            return errorMessage.toLowerCase().includes("session") && errorMessage.toLowerCase().includes("expired");
        }
    }
    return false;
};

function post(name, path, { body }) {
    let url = process.env.REACT_APP_api_server + "/" + name + path;

    const headers = {
        "Content-Type": "application/json",
        token: "Basic " + localStorage.getItem("token"),
        sub: localStorage.getItem("sub"),
    };
    return new Promise(function (resolve, reject) {
        axios
            .post(url, body, { headers })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                if (isSessionExpiredError(err)) {
                    logoutAndRedirect();
                }
                reject(err);
            });
    });
}

function get(name, path) {
    return new Promise(function (resolve, reject) {
        // let url;
        let url = process.env.REACT_APP_api_server + "/" + name + path;
        const headers = {
            "Content-Type": "application/json",
            token: "Basic " + localStorage.getItem("token"),
            // sub: localStorage.getItem('sub')
        };

        axios
            .get(url, { headers })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                if (isSessionExpiredError(err)) {
                    logoutAndRedirect();
                }
                reject(err);
            });
    });
}

function put(name, path, { body }) {
    // let url;
    const headers = {
        "Content-Type": "application/json",
        token: "Basic " + localStorage.getItem("token"),
        sub: localStorage.getItem("sub"),
    };

    let url = process.env.REACT_APP_api_server + "/" + name + path;

    return new Promise(function (resolve, reject) {
        axios
            .put(url, body, { headers })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                if (isSessionExpiredError(err)) {
                    logoutAndRedirect();
                }
                reject(err);
            });
    });
}

function del(name, path, options) {
    const headers = {
        "Content-Type": "application/json",
        token: "Basic " + localStorage.getItem("token"),
        sub: localStorage.getItem("sub"),
    };

    let url = process.env.REACT_APP_api_server + "/" + name + path;
    return new Promise(function (resolve, reject) {
        axios
            // axios sends a DELETE body via the `data` config; undefined when no body is passed.
            .delete(url, { headers, data: options?.body })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                if (isSessionExpiredError(err)) {
                    logoutAndRedirect();
                }
                reject(err);
            });
    });
}
// function callApi(path, method, body) {
//     let url;
//     axios.post(url).then(res => {

//     })
// }

function upload(name, path, body) {
    let url = process.env.REACT_APP_api_server + "/" + name + path;
    const headers = {
        "Content-Type": "multipart/form-data",
        token: "Basic " + localStorage.getItem("token"),
        sub: localStorage.getItem("sub"),
    };
    return new Promise(function (resolve, reject) {
        axios({
            method: "post",
            url: url,
            data: body,
            headers: headers,
        })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                if (isSessionExpiredError(err)) {
                    logoutAndRedirect();
                }
                reject(err);
            });
    });
}

function uploadDelete(name, path, { body }) {
    let url = process.env.REACT_APP_api_server + "/" + name + path;
    const headers = {
        "Content-Type": "application/json",
        token: "Basic " + localStorage.getItem("token"),
        sub: localStorage.getItem("sub"),
    };
    return new Promise(function (resolve, reject) {
        axios
            .post(url, body, { headers })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                if (isSessionExpiredError(err)) {
                    logoutAndRedirect();
                }
                reject(err);
            });
    });
}

// Amplify's API.cancel(promise, reason) aborts an in-flight request.
// OffLineAPI doesn't track abort controllers, so cancel becomes a no-op.
// Callers that relied on cancellation will see the old request resolve/reject
// normally instead of being cancelled — acceptable for the EC2 migration.
function cancel(_promise, _reason) {
    return false;
}

export const OffLineAPI = {
    post,
    get,
    put,
    del,
    upload,
    uploadDelete,
    cancel,
};
